import gsap from 'gsap';
import React, { createRef, useCallback, useEffect } from 'react';
import { Icon } from '..';
export const IconArrows = ({ className, onDone, running }) => {
    const wrapperRef = createRef();
    const triggerDone = useCallback(() => {
        if (onDone) {
            onDone();
        }
    }, [onDone]);
    useEffect(() => {
        if (running) {
            const wrapper = wrapperRef.current;
            const allLayer = wrapper?.querySelectorAll('path');
            if (!allLayer) {
                return;
            }
            gsap.to(allLayer, {
                keyframes: [
                    {
                        x: (index) => (index === 0 ? -2 : 2),
                        duration: 0.1,
                    },
                    {
                        x: (index) => (index === 0 ? 0.5 : -0.5),
                        duration: 0.15,
                    },
                    {
                        x: 0,
                        duration: 0.25,
                        onComplete: triggerDone,
                    },
                ],
            });
        }
    }, [running]);
    return (React.createElement("div", { className: className, ref: wrapperRef },
        React.createElement(Icon.Swap, null)));
};
//# sourceMappingURL=Arrows.js.map